import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";

const FtcSettings = ({ company, open, onClose, onSave }) => {
  const handleClose = () => {
    onClose();
  };

  const handleSave = () => {
    onSave();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        },
      }}
    >
      <DialogTitle sx={{ p: 3 }}>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Box display='flex' alignItems='center' gap={1}>
            <SettingsIcon color='primary' />
            <Typography variant='h6' fontWeight={600}>
              Settings
            </Typography>
          </Box>
          <IconButton onClick={handleClose} size='small'>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 4 }}>
        <Box>
          <Typography
            variant='h6'
            fontWeight={600}
            sx={{ mb: 3.5, color: "text.primary" }}
          >
            Foreign Income Currency Used
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <Box
              sx={{
                p: 3,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2.5,
                backgroundColor: "background.paper",
                transition: "all 0.2s ease",
                "&:hover": {
                  borderColor: "primary.main",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                },
              }}
            >
              <Typography
                variant='caption'
                fontWeight={600}
                color='text.secondary'
                sx={{
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  mb: 1,
                  display: "block",
                }}
              >
                Base Currency
              </Typography>
              <Typography
                variant='h5'
                fontWeight={500}
                sx={{ color: "text.primary" }}
              >
                {company?.currency || "—"}
              </Typography>
            </Box>

            <Box
              sx={{
                p: 3,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2.5,
                backgroundColor: "background.paper",
                transition: "all 0.2s ease",
                "&:hover": {
                  borderColor: "primary.main",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                },
              }}
            >
              <Typography
                variant='caption'
                fontWeight={600}
                color='text.secondary'
                sx={{
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  mb: 1,
                  display: "block",
                }}
              >
                Currency Rate
              </Typography>
              <Typography
                variant='h5'
                fontWeight={500}
                sx={{
                  color: "text.primary",
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                {company?.currencyRate ? company.currencyRate.toFixed(4) : "—"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button onClick={handleClose} variant='contained'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FtcSettings;
